module.exports = __webpack_public_path__ + "static/media/party_payment.9419f0b2.svg";